import { getApiBaseUrl } from '../../config/runtimeConfig';
import { sessionFetch } from '../../services/session';

async function request(path, options = {}) {
  let response;
  try {
    response = await sessionFetch(`${getApiBaseUrl()}/users${path}`, {
      credentials: 'include', ...options,
      headers: { Accept: 'application/json', ...options.headers },
      signal: AbortSignal.timeout(20000),
    });
  } catch (error) {
    throw new Error(error.name === 'TimeoutError' ? 'The request timed out. Please try again.' : 'Unable to connect. Please try again.');
  }
  const data = await response.json().catch(() => null);
  if (!response.ok) throw Object.assign(new Error(data?.message || 'Unable to complete the user request.'), { status: response.status });
  return data;
}

const readsInFlight = new Map();
function shareRead(path, select = data => data) {
  const key = `${getApiBaseUrl()}/users${path}`;
  if (!readsInFlight.has(key)) {
    readsInFlight.set(key, request(path).then(select).finally(() => readsInFlight.delete(key)));
  }
  return readsInFlight.get(key);
}

export function listUsers() { return shareRead('', data => data.users); }
export function listRoles() { return shareRead('/roles', data => data.roles); }
export async function createUser(payload) {
  return (await request('', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })).user;
}
export async function updateUser(id, payload) {
  return (await request(`/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })).user;
}
export async function deactivateUser(id) {
  return (await request(`/${id}/deactivate`, { method: 'PATCH' })).user;
}
export async function deleteUser(id) {
  return (await request(`/${id}`, { method: 'DELETE' })).user;
}
export async function resetUserPassword(id) {
  return request(`/${id}/reset-password`, { method: 'POST' });
}
export function getUserPermissions(id) { return shareRead(`/${id}/permissions`); }
export function saveUserPermissions(id, permissionIds) {
  return request(`/${id}/permissions`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ permissionIds }) });
}
